import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import styles from './wish-list-item.module.scss';
import HeartFilledIcon from '@tradera/blueprint/theme/icons2/heart-fill.svg?jsx';
import { Button } from '../atoms/button/button';

export const WishListButton = ({ className, disabled, onClick, toggled }) => {
    const { t } = useTranslator();
    const text = toggled
        ? t('itemCard_savedToWishlist')
        : t('itemCard_saveToWishlist');

    const iconClasses = `icon icon-md ${styles.icon} icon-stroke-white ${
        toggled ? 'icon-danger' : ''
    }`;

    const combinedClassName = `btn btn-sm p-0 ${styles.button}
        ${className || ''}`;

    return (
        <Button
            theme="unbutton"
            aria-label={text}
            className={combinedClassName}
            disabled={disabled}
            onClick={onClick}>
            {toggled ? (
                <HeartFilledIcon className={iconClasses} />
            ) : (
                <>
                    <HeartFilledIcon
                        className={`${iconClasses} icon-dark-50 ${styles.hoverHide}`}
                    />
                    <HeartFilledIcon
                        className={`${iconClasses} icon-danger ${styles.hoverShow}`}
                    />
                </>
            )}
        </Button>
    );
};
